import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import BaseAdapter from "../base/BaseAdapter";
import { getShareMessage } from "../../core/utils";
var QQAdapter = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(QQAdapter, _BaseAdapter);
  var _super = _createSuper(QQAdapter);
  function QQAdapter(native) {
    var _this;
    _classCallCheck(this, QQAdapter);
    return _this = _super.call(this, native, 'https://open.mobile.qq.com/sdk/qqapi.js?_bid=152', function () {
      return _this.mqq = window.mqq;
    });
  }
  _createClass(QQAdapter, [{
    key: "share",
    value: function share(shareMessage) {
      var shareObj = getShareMessage(shareMessage);
      window.mqq.ui.setActionButton({
        title: shareObj.text,
        hidden: false
      }, function () {
        window.mqq.data.setShareInfo(shareObj);
        window.mqq.ui.showShareMenu();
      });
    }
  }, {
    key: "getQRCodeScan",
    value: function getQRCodeScan(obj, callback) {
      window.mqq.ui.scanQRcode(obj, function (res) {
        if (callback) {
          callback({
            code: res ? 0 : -1,
            resultString: res || '',
            resultStr: res || '',
            // 兼容老版本的返回值
            msg: ''
          });
        }
      });
    }
  }, {
    key: "close",
    value: function close() {
      window.mqq.ui.popBack();
    }
  }]);
  return QQAdapter;
}(BaseAdapter);
_defineProperty(QQAdapter, "pluginName", 'QQAdapter');
_defineProperty(QQAdapter, "platform", [{
  rule: /QQ\//i,
  name: 'qq'
}]);
export { QQAdapter as default };